import { render, staticRenderFns } from "./ValoresEnEspera.vue?vue&type=template&id=2e58d7ca&scoped=true&"
import script from "./ValoresEnEspera.vue?vue&type=script&lang=js&"
export * from "./ValoresEnEspera.vue?vue&type=script&lang=js&"
import style0 from "./ValoresEnEspera.vue?vue&type=style&index=0&id=2e58d7ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e58d7ca",
  null
  
)

export default component.exports